import { playAudioBlob } from './audioManager';

/**
 * Play an audio Blob using the Web Audio API.
 * More reliable than <audio> in Android WebView.
 * Delegates to the global audioManager so only one audio plays at a time.
 */
export function playAudioBuffer(blob, callbacks = {}) {
  return playAudioBlob(blob, callbacks);
}
